import React from 'react';
import Reveal from '../ui/Reveal';
import CountdownDisplay from './CountdownDisplay';

interface FinalCtaSectionProps {
  days: number;
  hours: number;
  minutes: number;
  seconds: number;
  fechaLabel: string;
  horaLabel: string;
}

const FinalCtaSection: React.FC<FinalCtaSectionProps> = ({ days, hours, minutes, seconds, fechaLabel, horaLabel }) => {
  return (
    <section className="relative py-24 md:py-28">
      <div className="mx-auto max-w-7xl px-5">
        <Reveal className="relative overflow-hidden rounded-[30px] border border-white/10 bg-white/5 p-10 text-center backdrop-blur-md md:p-16">
          <img
            src="/images/06-masterclass/masterclass-10.jpeg"
            alt=""
            aria-hidden="true"
            loading="lazy"
            className="pointer-events-none absolute inset-0 h-full w-full animate-kenburns object-cover opacity-20"
          />
          <div
            className="pointer-events-none absolute inset-0"
            style={{ background: 'linear-gradient(180deg, rgba(7,12,36,.82), rgba(9,15,48,.92))' }}
          />
          <div
            className="pointer-events-none absolute -left-16 -top-24 h-72 w-72 rounded-full blur-3xl"
            style={{ background: 'radial-gradient(circle, rgba(218,35,157,.4), transparent 65%)' }}
          />
          <div
            className="pointer-events-none absolute -bottom-24 -right-16 h-72 w-72 rounded-full blur-3xl"
            style={{ background: 'radial-gradient(circle, rgba(63,134,255,.4), transparent 65%)' }}
          />

          <div className="relative">
            <div className="mx-auto mb-6 w-fit animate-float">
              <img src="/images/01-homepage/logoinfinitywits.svg" alt="Infinity Wits" className="h-14 w-auto" />
            </div>
            <h2 className="mx-auto max-w-3xl font-display text-3xl font-extrabold leading-tight md:text-5xl">
              Empieza a trabajar de una forma diferente con{' '}
              <span className="text-gradient-mc">Inteligencia Artificial</span>
            </h2>
            <p className="mx-auto mt-6 max-w-2xl font-light leading-relaxed text-white/65">
              Las herramientas de IA seguirán cambiando. Lo importante es desarrollar la capacidad de entender dónde
              aplicarlas, cómo usarlas, qué elegir y cómo incorporarlas a tu forma de trabajar.
            </p>
            <p className="mt-8 font-display text-xl font-bold md:text-2xl">
              No se trata solo de usar IA.
              <br />
              <span className="text-gradient-mc">Se trata de aprender a trabajar con IA.</span>
            </p>

            <div className="mt-8 flex flex-wrap items-center justify-center gap-2.5 text-sm">
              <span className="chip-mc rounded-lg px-4 py-2 text-white/80">{fechaLabel}</span>
              <span className="chip-mc rounded-lg px-4 py-2 text-white/80">{horaLabel} · Hora Perú</span>
              <span className="chip-mc flex items-center gap-2 rounded-lg px-4 py-2">
                <span className="h-2 w-2 animate-pulse rounded-full bg-mc-fuchsia" />
                100% online en vivo
              </span>
            </div>

            <div className="mt-6 flex justify-center">
              <CountdownDisplay days={days} hours={hours} minutes={minutes} seconds={seconds} />
            </div>

            <a href="#registro" className="btn-mc-glow mt-9 inline-block px-9 py-4">
              Quiero reservar mi acceso gratuito
            </a>
          </div>
        </Reveal>
      </div>
    </section>
  );
};

export default FinalCtaSection;
